import React, { useMemo, FC }    from 'react';
import { Box }                   from '@material-ui/core';
import { makeStyles }            from '@material-ui/core/styles';
import {
  TDataTableRow,
  IOption,
  ILinkButtonData,
}                                from '@typings/components';
import { IVinDecodeHistoryItem } from '@typings/dashboard';
import {
  VinWrapper,
  Dropdown,
  PageWrapper,
}                                from '@components/index';
import { getFormattedDate }      from '@utils/commonFunctions';
import { VinDecodeHistoryTable } from '@modules/dashboard/components/VinDecodeHistoryTable';

const useStyles = makeStyles({
  dropdownWrapper: {
    display        : 'flex',
    justifyContent : 'flex-end',
  },
});

const formatTitle = (item: IVinDecodeHistoryItem): string => {
  const year         = item?.year ?? '';
  const carBrandName = item?.carBrandName ?? '';
  const carModelName = item?.carModelName ?? '';

  return `${year} ${carBrandName} ${carModelName}`.trim();
};

const getTableRows = (
  vinDecodeHistory: IVinDecodeHistoryItem[] = [],
): TDataTableRow[] => vinDecodeHistory.reduce((
  acc: TDataTableRow[],
  historyItem: IVinDecodeHistoryItem,
) => {
  const row: TDataTableRow = [{
    value: <VinWrapper>{historyItem.vin ?? '—'}</VinWrapper>,
  }, {
    value: getFormattedDate(historyItem.dateTime, 'MM/DD/YY - hh:mm A z'),
  }, {
    value : historyItem.result ? 'Success' : 'Fail',
    align : 'center',
  }, {
    value: historyItem.creditUnionName ?? '—',
  }, {
    value : historyItem.vehicleBodyStyle ?? '—',
    align : 'center',
  }, {
    value: <p style={{ color: '#0063A5' }}>{formatTitle(historyItem)}</p>,
  }];

  acc.push(row);

  return acc;
}, []);

interface IProps {
  rowsPerPage                : number;
  currentPage                : number;
  vinDecodeHistory           : IVinDecodeHistoryItem[];
  totalVinDecodeHistoryCount : number;
  isLoading                  : boolean;
  curCuid                    : string | null;
  accountsOptions            : IOption[];
  isFilterDisabled           : boolean;
  navLinksData               : ILinkButtonData[];
  handleChangePage           : (page: number) => void;
  onCuidChange               : (cuidOption: IOption) => void;
}

export const VinDecodeHistoryPage: FC<IProps> = ({
  rowsPerPage,
  currentPage,
  vinDecodeHistory,
  totalVinDecodeHistoryCount,
  isLoading,
  curCuid,
  accountsOptions,
  isFilterDisabled,
  navLinksData,
  handleChangePage,
  onCuidChange,
}) => {
  const { dropdownWrapper } = useStyles();

  const tableRows = useMemo(
    (): TDataTableRow[] => getTableRows(vinDecodeHistory),
    [vinDecodeHistory],
  );

  return (
    <PageWrapper navLinksData={navLinksData}>
      <Box className={dropdownWrapper}>
        <Dropdown
          width               = {300}
          field               = {{ value: curCuid }}
          options             = {accountsOptions}
          placeholder         = "Select Credit Union"
          disabled            = {isFilterDisabled}
          customOnValueChange = {onCuidChange}
        />
      </Box>

      <VinDecodeHistoryTable
        tableRows                   = {tableRows}
        rowsPerPage                 = {rowsPerPage}
        currentPage                 = {currentPage}
        handleChangePage            = {handleChangePage}
        totalVinDecodeHistoryCount  = {totalVinDecodeHistoryCount}
        isLoading                   = {isLoading}
      />
    </PageWrapper>
  );
};
